import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './frkSaleEntry.css'

const baseURL = localStorage.getItem('baseURL')

function FrkDataEntry({setIsLoggedIn}) {

    const [data, updateData] = useState({
        "bill": "",
        "date": "",
        "veh": "",
        "weight": "",
        "driver_mob": "",
        "rate": "",
        "freight_rate": "",
        "loading_party": "",
        "delivery_loc": "",
        "transporter": "",
        "gst_amount": "",
        "narration": "-"
    });

    const handleDataUpdate = (e)=>{
        const val = e.target.value;
        const key = e.target.attributes['data-nam'].nodeValue;
        updateData((data)=>({
            ...data,
            [key] : val
        }))
    }

    const handleFocus = async(e)=>{
        
    }

    const sendData = (e)=>{
        e.preventDefault();
        if (data==null || data==''){
            window.alert("Insert some data");
            return;
        }
        for (const key in data){
            if (data[key]==""){
                window.alert(`${key} is empty`);
                return;
            }
        }
        axios.post(baseURL+'/frk/sale_data', {sale_data: data}, {headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }}).then((response)=>{
            console.log(response);
            if (response.status!=200){
                console.log(response);
                window.alert('You are not logged-in');
                setIsLoggedIn(false);
            } else {
                const inputs = document.querySelectorAll('.frkDataEntry form input');
                inputs.forEach(item=>item.value='')
                inputs[0].focus();
                updateData({
                    "bill": "",
                    "date": "",
                    "veh": "",
                    "weight": "",
                    "driver_mob": "",
                    "rate": "",
                    "freight_rate": "",
                    "loading_party": "",
                    "delivery_loc": "",
                    "transporter": "",
                    "gst_amount": "",
                    "narration": "-"
                });
                window.alert('Data Updated');
            }
        }).catch(err=>{
            console.log(err);
            window.alert('You are not logged-in');
            setIsLoggedIn(false);
        });
    }

  return (
    <section className='frkDataEntry'>
        <p>FRK Sale Data Entry</p>
            <form onSubmit={sendData}>
                <div>
                    <label>Bill No.</label>
                    <input data-nam='bill' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Date</label>
                    <input data-nam='date' onChange={handleDataUpdate} type="date"></input>
                </div>
                <div>
                    <label>Vehicle No.</label>
                    <input onFocus={handleFocus} data-nam='veh' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Weight</label>
                    <input data-nam='weight' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Driver Mob.</label>
                    <input data-nam='driver_mob' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Rate</label>
                    <input data-nam='rate' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Freight Rate</label>
                    <input data-nam='freight_rate' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Loading Party</label>
                    <input data-nam='loading_party' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Delivery</label>
                    <input data-nam='delivery_loc' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Transporter</label>
                    <input data-nam='transporter' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>GST Amount</label>
                    <input data-nam='gst_amount' onChange={handleDataUpdate} type="number" step="0.01"></input>
                </div>
                <div data-nam='narration'>
                    <label>Narration</label>
                    <input data-nam='narration' onChange={handleDataUpdate} type="text"></input>
                </div>
                <button>Save</button>
            </form>
    </section>
  )
}

export default FrkDataEntry